import React from 'react'
import { useSelector } from 'react-redux'
import { Link as RouterLink } from 'react-router-dom'

import { Box, Divider, Typography, Link } from '@material-ui/core'

import { BundleType } from '../../model/bundles.model'
import { selectHasSelectedBundles } from '../../store/bundles.selectors'

import { RootState } from '~/core/store/root.reducer'
import { selectBundlesWithFormattedPrice } from '~/prices/prices.selectors'
import PATHS from '~/router/paths'

export default function BundlesSummary({ id }: { id: string }) {
  const selectedBonus = useSelector((state: RootState) =>
    selectBundlesWithFormattedPrice(state, id, BundleType.BONUS),
  )
  const selectedPromos = useSelector((state: RootState) =>
    selectBundlesWithFormattedPrice(state, id, BundleType.PROMOS),
  )

  const hasBundles = useSelector((state: RootState) => selectHasSelectedBundles(state, id))

  return hasBundles ? (
    <Box pt={4}>
      <Box>
        <Box mb={5}>
          <Typography variant="subtitle1">OPCIONES AÑADIDAS</Typography>
        </Box>
        {selectedBonus.map((bonus) => (
          <Box key={bonus.id} display="flex" flexDirection="row" alignItems="baseline" mb={4}>
            <Typography variant="body2">Bono: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook={`${id}.tariffName`}>
                {bonus.name}{' '}
                {bonus.durationText.map((text) => (
                  <span key={`bonus-summary-${text.payment}`}>
                    {text.pretext}
                    <strong>{text.payment}</strong>
                    {text.duration}
                  </span>
                ))}
              </Typography>
            </Box>
          </Box>
        ))}
        {selectedPromos.map((promo) => (
          <Box key={promo.id} display="flex" flexDirection="row" alignItems="baseline" mb={4}>
            <Typography variant="body2">Descuento: </Typography>
            <Box ml={1}>
              <Typography variant="subtitle2" data-hook={`${id}.tariffName`}>
                {promo.name}{' '}
                {promo.durationText.map((text) => (
                  <span key={`promos-summary-${text.payment}`}>
                    {text.pretext}
                    <strong>{text.payment}</strong>
                    {text.duration}
                  </span>
                ))}
              </Typography>
            </Box>
          </Box>
        ))}
        <Box>
          <Link component={RouterLink} to={PATHS.OFFER_SETUP} underline="always">
            Modificar opciones
          </Link>
        </Box>
      </Box>
      <Box mt={7}>
        <Divider className="dotted" />
      </Box>
    </Box>
  ) : (
    <div />
  )
}
